/**
 * Agriko About Page - Scroll Reveal Animations
 * Smooth scroll, card stagger, and .is-visible class alias
 * for backward-compatible CSS until the CSS rebuild replaces
 * .is-visible with [data-reveal="active"].
 */

(function() {
  'use strict';

  var cleanupListeners = [];

  /**
   * Alias .is-visible onto elements that theme.js marks with
   * data-reveal="active" so existing CSS keeps working.
   */
  function initRevealClassAlias() {
    if (!('IntersectionObserver' in window)) {
      var fallbackElements = document.querySelectorAll('[data-reveal]');
      for (var j = 0; j < fallbackElements.length; j++) {
        fallbackElements[j].classList.add('is-visible');
        fallbackElements[j].setAttribute('data-reveal', 'active');
      }
      return;
    }

    var observer = new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          entry.target.setAttribute('data-reveal', 'active');
          obs.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      threshold: 0.1,
      rootMargin: "0px"
    });

    // We observe all elements that have [data-reveal]
    var elements = document.querySelectorAll('[data-reveal]');
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].getAttribute('data-reveal') === 'active' || elements[i].classList.contains('is-visible')) {
        continue;
      }
      observer.observe(elements[i]);
    }

    cleanupListeners.push(function() {
      observer.disconnect();
    });
  }

  /**
   * Add smooth scroll for all anchor links with matching targets
   */
  function initSmoothScroll() {
    var links = document.querySelectorAll('a[href^="#"]');
    function handleClick(e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', handleClick);
    }
    cleanupListeners.push(function() {
      for (var i = 0; i < links.length; i++) {
        links[i].removeEventListener('click', handleClick);
      }
    });
  }

  /**
   * Add stagger animation to cards on hover
   */
  function initCardStagger() {
    var grids = document.querySelectorAll('.ag-about-testimonials__grid, .ag-about-ingredients__grid');
    for (var i = 0; i < grids.length; i++) {
      (function(grid) {
        var cards = grid.querySelectorAll('[data-reveal]');
        grid.addEventListener('mouseenter', function() {
          for (var j = 0; j < cards.length; j++) {
            cards[j].style.transitionDelay = (j * 0.05) + 's';
          }
        }, { once: true });
      })(grids[i]);
    }
  }

  function initHeroPoster() {
    var video = document.querySelector('body[data-page-handle="about"] .ag-home-hero__video');
    var posterUrl = document.body ? document.body.getAttribute('data-about-hero-poster') : '';
    if (!video) return;
    if (posterUrl && video.getAttribute('poster') !== posterUrl) {
      video.setAttribute('poster', posterUrl);
      if (video.readyState === 0 && typeof video.load === 'function') {
        video.load();
      }
    }
  }

  /**
   * Initialize all effects when DOM is ready
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  }

  function initAll() {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      // Show all elements immediately — no animation
      var elements = document.querySelectorAll('[data-reveal]');
      for (var i = 0; i < elements.length; i++) {
        elements[i].classList.add('is-visible');
      }
    }

    // Always run the alias so CSS .is-visible rules work
    // when theme.js sets data-reveal="active"
    initRevealClassAlias();

    initSmoothScroll();
    initHeroPoster();

    if (!prefersReducedMotion) {
      initCardStagger();
    }
  }

  window.addEventListener('pagehide', function() {
    for (var i = 0; i < cleanupListeners.length; i++) {
      cleanupListeners[i]();
    }
    cleanupListeners.length = 0;
  });

  init();

  window.AgrikoAboutReveal = {
    init: initAll
  };

})();
